// extracted by mini-css-extract-plugin
module.exports =  {"root":"ANJ0tWqPPgmB5X4dfmM1"};